import { HeadLine } from "../../layouts/headers/HeadLine";
import CSS from 'csstype';
import { Link } from "react-router-dom";
import { NoAuthAlertComponent } from "../../components/card/NoAuthAlertComponent";
import { useSelector } from "react-redux";

export const ExperiencesMainPage = () => {

    const user = useSelector((store: any) => (store.auth));

    const bgimage: CSS.Properties = { background: "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%), url('/assets/img/experiencias_bg.png') no-repeat center center / cover" };

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Experiencias Románticas' backurl='/' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="bg_room_page flex justify-center items-center bg_page_top" style={bgimage}>
                    <img src="/assets/img/icons/experiencias-icon.svg" alt="Icono room" />
                </div>
            </div>

            <div className="absolute z-1 w-full border shadow detail-process-room-container pb-4">


                {
                    !user &&
                    (<div className="mt-4" style={{ marginRight: '-14px' }}>
                        <NoAuthAlertComponent />
                    </div>)
                }

                <Link to={'detail'} className='w-full rounded-md border shadow flex justify-start items-center p-2 mt-4'>
                    <img className="rounded-lg" src="/assets/img/experiencias_1.png" alt="img 1" width={'94px'} height={'94px'} />
                    <span className='ml-4'>
                        Cena a la Orilla del Mar
                    </span>
                </Link>

                <div className='w-full rounded-md border shadow flex justify-start items-center p-2 mt-4'>
                    <img className="rounded-lg" src="/assets/img/experiencias_2.png" alt="img 1" width={'94px'} height={'94px'} />
                    <span className='ml-4'>
                        Cena especial en Mikado Japanese Teppan Yaki
                    </span>
                </div>

                <div className='w-full rounded-md border shadow flex justify-start items-center p-2 mt-4'>
                    <img className="rounded-lg" src="/assets/img/experiencias_3.png" alt="img 1" width={'94px'} height={'94px'} />
                    <span className='ml-4'>
                        Cena especial en Italian Roma’s Lover
                    </span>
                </div>

                <Link to={'detail2'} className='w-full rounded-md border shadow flex justify-start items-center p-2 mt-4'>
                    <img className="rounded-lg" src="/assets/img/experiencias_4.png" alt="img 1" width={'94px'} height={'94px'} />
                    <span className='ml-4'>
                        Masaje Romántico by Israel Galindo “El Muñeco sexual”
                    </span>
                </Link>
            </div>
        </>
    );
};
